import { formSubmitClear, formComplete } from 'actions/forms'
import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'

export const BANKTRANSFER_SAVE_REQUEST = 'BANKTRANSFER_SAVE_REQUEST'
export const BANKTRANSFER_SAVE_ERROR = 'BANKTRANSFER_SAVE_ERROR'
export const BANKTRANSFER_SAVE_COMPLETE = 'BANKTRANSFER_SAVE_COMPLETE'

export const BANKDETAIL_GET = 'BANKDETAIL_GET'
export const BANKDETAIL_GET_ERROR = 'BANKDETAIL_GET_ERROR'
export const BANKDETAIL_RECEIVED = 'BANKDETAIL_RECEIVED'

export const BANKTRANSFERS_GET = 'BANKTRANSFERS_GET'
export const BANKTRANSFERS_GET_ERROR = 'BANKTRANSFERS_GET_ERROR'
export const BANKTRANSFERS_RECEIVED = 'BANKTRANSFERS_RECEIVED'

export const BANKACCOUNTS_GET = 'BANKACCOUNTS_GET'
export const BANKACCOUNTS_GET_ERROR = 'BANKACCOUNTS_GET_ERROR'
export const BANKACCOUNTS_RECEIVED = 'BANKACCOUNTS_RECEIVED'

const saveBankTransferRequest = () => ({
  type: BANKTRANSFER_SAVE_REQUEST,
})

const saveBankTransferComplete = result => ({
  result,
  type: BANKTRANSFER_SAVE_COMPLETE,
})

const fetching = type => ({
  type,
})

const fetchingerror = type => ({
  type,
})

const bankDetailReceive = bankDetail => ({
  type: BANKDETAIL_RECEIVED,
  bankDetail,
})

const bankTransfersReceive = bankTransfers => ({
  type: BANKTRANSFERS_RECEIVED,
  bankTransfers,
})

const bankAccountsSaved = bankAccounts => ({
  type: BANKACCOUNTS_RECEIVED,
  bankAccounts,
})

export function getBankTransfers(employeeId) {
  return (dispatch) => {
    dispatch(fetching(BANKTRANSFERS_GET))
    agent.AccountsAndLoans.listbanktransfers(employeeId)
      .then((result) => {
        dispatch(bankTransfersReceive(result, BANKTRANSFERS_RECEIVED))
      })
      .catch((rawError) => {
        // console.error('getBankTransfers error', rawError, rawError.stack, window.location)
        console.error('Getting bank transfers error')
        const { error, status, description } = parseError(rawError)

        if (status === constants.ERROR.INTERNAL_SERVER) {
          dispatch(push({
            pathname: '/error',
            search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
          }))
        } else if (status === constants.ERROR.UNAUTHORIZED) {
          updateSessionObject()
        } else if (error.message === constants.ERROR.CANCEL_REQUEST) {
          console.warn('CANCEL_REQUEST')
        } else {
          dispatch(notify(description))
          dispatch(notify('Error fetching bank transfers', 'warning'))
          dispatch(push({ pathname: '/' }))
        }
      })
  }
}

export function getSavedBankAccounts(employeeId) {
  return (dispatch) => {
    dispatch(fetching(BANKACCOUNTS_GET))
    agent.AccountsAndLoans.savedbankaccounts(employeeId)
      .then((savedAccounts) => {
        dispatch(bankAccountsSaved(savedAccounts, BANKACCOUNTS_RECEIVED))
      })
      .catch((rawError) => {
        // console.error('getBankTransfers error', rawError, rawError.stack, window.location)
        console.error('Getting saved bank accounts error')
        const { error, status, description } = parseError(rawError)
        if (status === constants.ERROR.INTERNAL_SERVER) {
          dispatch(push({
            pathname: '/error',
            search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
          }))
        } else if (status === constants.ERROR.UNAUTHORIZED) {
          updateSessionObject()
        } else if (error.message === constants.ERROR.CANCEL_REQUEST) {
          console.warn('CANCEL_REQUEST')
        } else {
          dispatch(notify(description))
          dispatch(notify('Error fetching bank transfers', 'warning'))
          dispatch(push({ pathname: '/' }))
        }
      })
  }
}

export const addBankTransfer = (payload, formId, redirect = true) => (dispatch) => {
  dispatch(saveBankTransferRequest())
  agent.AccountsAndLoans.create(payload).then((response) => {
    dispatch(saveBankTransferComplete(response))
    dispatch(notify('Bank transfer sent'))
    dispatch(getBankTransfers(payload.employee_id))
    dispatch(formComplete(formId))
  }).catch((rawError) => {
    const { error, status, errorMessage } = parseError(rawError)
    if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
      dispatch(push({
        pathname: '/error',
        search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
      }))
    } else if (status === constants.ERROR.UNAUTHORIZED) {
      updateSessionObject()
    } else {
      dispatch(notify(errorMessage))
      dispatch(notify('Error sending bank transfer request, please try again later', 'warning'))
      // console.warn('ERR <addBankTransfer>: ', errorMessage, error)
      dispatch(formSubmitClear(formId))
    }
  })
}

export function getBankDetail(bankBSB, employeeId) {
  return (dispatch) => {
    dispatch(fetching(BANKDETAIL_GET))
    agent.BankDetail.details(bankBSB, employeeId).then((response) => {
      let bankDetail = {}
      if (response.length > 0) {
        bankDetail = response[0]
      }
      dispatch(bankDetailReceive(bankDetail))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify('Error getting the bank detail, please try again later', 'warning'))
        // console.warn('ERR <getBankDetail>: ', description, error)
        dispatch(fetchingerror(BANKDETAIL_GET_ERROR))
      }
    })
  }
}






// WEBPACK FOOTER //
// ./src/actions/bankTransferForm.js